import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.logout-saml', {
        url: '/logoutSAML',
        component: 'samlLogout',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-logout/saml-logout.state.js